import { render, staticRenderFns } from "./cr-periods.vue?vue&type=template&id=b8f228d8"
import script from "./cr-periods.ts?vue&type=script&lang=ts&external"
export * from "./cr-periods.ts?vue&type=script&lang=ts&external"
import style0 from "./cr-periods.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8f228d8')) {
      api.createRecord('b8f228d8', component.options)
    } else {
      api.reload('b8f228d8', component.options)
    }
    module.hot.accept("./cr-periods.vue?vue&type=template&id=b8f228d8", function () {
      api.rerender('b8f228d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin-periods/cr-periods/cr-periods.vue"
export default component.exports